import {first, switchMap} from 'rxjs/operators';
declare var fmcPhoneValidator: any;
declare var _: any;
import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {FmcElementsComponent} from '../fmc-elements.component';
import {UntypedFormControl, AbstractControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {timer, EMPTY as empty, of as observableOf} from 'rxjs';
import * as lodash from 'lodash';
import {environment} from '../../environments/environment';
import {noWhitespaceValidator} from '../common';
import {NgIf} from '@angular/common';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

@Component({
  selector: 'fmc-sensis-mobile',
  templateUrl: './sensis-mobile.component.html',
  styleUrls: ['./sensis-mobile.component.css'],
  standalone: true,
  imports: [
    NgIf,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule
  ]
})
export class SensisMobileComponent extends FmcElementsComponent implements OnInit, AfterViewInit {
  @Input() public centralisedValidation = false;
  @Input() public acceptedPhoneTypes: any = [];
  @Input() public rejectedPhoneTypes: any = [];
  @Input() public allowBypass = false;
  public defaultControl = new UntypedFormControl();
  public defaultControlType = 'FormControl';
  public patchedValue: any;
  public originalPhoneNumber: string;

  ngOnInit() {
    super.ngOnInit();

    if (this.activeLook === 'lite') {
      this.acceptedPhoneTypes = [];
      this.rejectedPhoneTypes = [];
    }
  }

  ngOnChanges(changes) {
    if ((changes.acceptedPhoneType || changes.rejectedPhoneTypes) && this.formControl) {
      this.formControl.updateValueAndValidity();
    }

    if (changes && changes.parentFormGroup && changes.parentFormGroup.currentValue) {
      this.originalPhoneNumber = (changes.parentFormGroup.currentValue.value.phoneNumber) ?
        changes.parentFormGroup.currentValue.value.phoneNumber.trim() : (changes.parentFormGroup.currentValue.value.phone) ?
          changes.parentFormGroup.currentValue.value.phone.trim() : null;
    }
  }

  async ngAfterViewInit() {
    await this.loadScript(`${environment.api.lcaDomain}/application/js/libphonenumber-max.min.js`);
    await this.loadScript(`https://cdn.jsdelivr.net/npm/axios@0.19.2/dist/axios.min.js`);
    await this.loadScript(`${environment.api.lcaDomain}/application/js/firstmac-phone-validation-2.0.js`);
    _ = lodash;

    this.formControl.setAsyncValidators(this.phoneValidation());
    this.formControl.updateValueAndValidity();
  }

  private loadScript(scriptUrl: string) {
    return new Promise((resolve, reject) => {
      const scriptElement = document.createElement('script');
      scriptElement.src = scriptUrl;
      scriptElement.onload = resolve;
      document.body.appendChild(scriptElement);
    });
  }

  public phoneValidation(): any {
    return (control: AbstractControl): { [key: string]: any } => {
      // exit on empty

      const noWhitespaceError = noWhitespaceValidator(control as UntypedFormControl);
      if (noWhitespaceError) {
        return observableOf({telno: true}).toPromise();
      }

      const initValue = _.trim(control.value);

      if (initValue === '' || initValue === this.originalPhoneNumber) {
        return empty.toPromise();
      }

      return timer(1000).pipe(switchMap(async () => {
        const res = await fmcPhoneValidator(initValue, 'sensis');
        let {
          valid,
          formatted,
          phoneType
        } = res;

        let validPhoneType = false;
        if (phoneType && this.acceptedPhoneTypes && this.rejectedPhoneTypes) {
          const acceptedPhoneType = (!this.acceptedPhoneTypes || this.acceptedPhoneTypes.length === 0 || this.acceptedPhoneTypes.includes(phoneType));
          const rejectedPhoneType = !!(this.rejectedPhoneTypes.length && this.rejectedPhoneTypes.includes(phoneType));
          validPhoneType = acceptedPhoneType && !rejectedPhoneType;
        }

        if (valid && !validPhoneType && formatted !== initValue) {
          control.patchValue(formatted, {emitEvent: false});
        }

        if (!valid || !validPhoneType) {
          if (!valid && validPhoneType && this.allowBypass) {
            control.patchValue(formatted, {emitEvent: false});
            this.formControl.clearAsyncValidators();
            return null;
          }

          this.formControl.setAsyncValidators(this.phoneValidation());
          return observableOf({telno: true}).toPromise();
        } else {
          if (formatted !== initValue) {
            this.patchedValue = formatted;
            control.patchValue(formatted, {emitEvent: false});
          }

          this.formControl.setAsyncValidators(this.phoneValidation());
          return null;
        }
      }), first());
    };
  }
}
